module.exports = __webpack_public_path__ + "static/media/mv_calm.90b266e1.jpg";